import React, { useRef, useEffect } from 'react';

import {
    Chart, LineController, LineElement, Filler, PointElement, LinearScale, TimeScale, Tooltip,
} from 'chart.js';
import 'chartjs-adapter-moment';
import PropTypes from 'prop-types';

// Import utilities
// import { tailwindConfig, formatValue } from '../utils/Utils';

Chart.register(LineController, LineElement, Filler, PointElement, LinearScale, TimeScale, Tooltip);

function LineChart03({
    data,
    className,
}) {

    const canvas = useRef(null);

    useEffect(() => {
        const ctx = canvas.current;
        // eslint-disable-next-line no-unused-vars
        // if (data.length > 0) {
            const chart = new Chart(ctx, {
                type: 'line',
                data: data,
                options: {
                    layout: {
                        padding: 20,
                    },
                    scales: {
                        y: {
                            display: true,
                            beginAtZero: true,
                            ticks: {
                                precision: 0
                            }
                        },
                        x: {
                            type: 'time',
                            time: {
                                parser: 'YYYY/MM/DD',
                                unit: 'day',
                                tooltipFormat: 'DD MMM YYYY',
                            },
                            grid: {
                                display: false,
                                drawBorder: false,
                            },
                            ticks: {
                                autoSkipPadding: 48,
                                maxRotation: 0,
                            },
                        },
                    },
                    plugins: {
                        legend: {
                            display: false,
                        },
                        tooltip: {
                            titleFont: {
                                weight: '600',
                            },
                            callbacks: {
                                label: (context) => context.parsed.y + ' Messages',
                            },
                        },
                    },
                    interaction: {
                        intersect: false,
                        mode: 'nearest',
                    },
                    animation: false,
                    maintainAspectRatio: false,
                    resizeDelay: 200,
                },
            });
            return () => chart.destroy();
        // }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);


    return (
        <div className="relative h-full">
            <canvas ref={canvas}></canvas>
        </div>
    );
}

LineChart03.propTypes = {
  data: PropTypes.object,
  className: PropTypes.string,
};

export default LineChart03;